import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl, IntlContext } from 'react-intl';
import { useFormikContext } from 'formik';
import { TextFieldWithLabel, SelectFieldWithLabel, RadioButtonsWithLabel, CheckboxWithLabel } from '../../../../components/FormFields';
import AppContext from '../../../../components/AppContext';
import { currentLang, currentLongLang } from '../../../../components/components/utils';
import { constants } from '../../../../constants'
import { API } from 'aws-amplify';

export default function MDMCallOutput({BNLabelType, ConfirmClient, ...props}) {
	const appContext = useContext(AppContext);
	const { messages } = useContext(IntlContext);
	
	const { values, isSubmitting, submitCount, errors } = useFormikContext();
	const {accountData} = appContext;
	
	const labels = {
		"sima.account.accountInfo.registrantInfoCheck.radio"	: useIntl().formatMessage({id:"sima.account.accountInfo.registrantInfoCheck.radio"}, {i: (chunks) => <i>{chunks}</i>})
		, "label.yes"											: useIntl().formatMessage({id:"label.yes"})
		, "label.yes.member.of.firm.authorized"					: useIntl().formatMessage({id:"label.yes.member.of.firm.authorized"}, {i: (chunks) => <i>{chunks}</i>})
	}
	
	const {clientRoles} = appContext.codeTables;
	const [businessData, setBusinessData] = useState({
		"companyLegalName" : ""
		, "companyOperatingName" : ""
		, "companyAddress" : ""
		, "companyCity" : ""
		, "companyCountry" : ""
		, "companyProvince" : ""
		, "companyPostalZipCode" : ""
		, "Telephone1" : ""
	});

	
	const disableOnSubmit = (submitCount !== 0 && isSubmitting && (!errors || Object.keys(errors).length === 0));
	
	const disableFirmCheckboxFromInitialValue = accountData?.ace_accounttype === constants.registrantInfoFirm ? true : false
	
	const handleBusinessSearchClick = () => {
		//TODO - put spinner on page
		appContext.setGlobalSpinnerCount(appContext.globalSpinnerCount + 1);
		let apiURL = "getBusinessAttributes";
		let apiPostObj = {
			body: {
				"ace_businessnumber": values.ace_businessnumber
			}
		}
		API.post("backend-api", apiURL, apiPostObj).then(function(response){
			
			let responseData = response;
			responseData.companyCountry = appContext?.codeTableLookup?.countries?.[response["companyCountryCode"]];   // converted to GUID from preliminaryData
			responseData.companyProvince = response.companyProvinceCode; //TODO - convert this to GUID from preliminaryData, when we start getting the MDM codes from mid-tier
			
			setBusinessData(responseData);
			
		}).catch(function(error){
			if (window.env.environment !== "prod") {
				console.log({error})
			}
			if (window.env.environment !== "local") {
				if (error.response.status === 406) {
					appContext.setFlashError({duration:-1, messages:[<FormattedMessage id="ace.businessNumber.doesNotExist" values={{bn: values.ace_businessnumber, b: chunks => <b>{chunks}</b>}} />]});
				} else {
					appContext.setFlashError({duration:-1, messages:[<FormattedMessage id="http.networkError" values={{p: (chunks) => <p>{chunks}</p>, a: (chunks) => <a href={"https://www.cbsa-asfc.gc.ca/contact/bis-sif-"+currentLongLang()+".html"} className="App-link" target="_blank" rel="noreferrer">{chunks}</a>}}/>]});
				}
			} else {
				setBusinessData({
					"companyLegalName" : messages["sima.account.accountInfo.companyLegalName.placeholder"]
					, "companyOperatingName" : messages["sima.account.accountInfo.companyOperatingName.placeholder"]
					, "companyAddress" : messages["sima.account.accountInfo.companyAddress.placeholder"]
					, "companyCity" : messages["sima.account.accountInfo.companyCity.placeholder"]
					, "companyCountry" : messages["sima.account.accountInfo.companyCountry.placeholder"]
					, "companyProvince" : messages["sima.account.accountInfo.companyProvince.placeholder"]
					, "companyPostalZipCode" : messages["sima.account.accountInfo.companyPostalZipCode.placeholder"]
					, "Telephone1" : messages["common.phoneNumber.ex"]
				});
			}
		}).finally(() => {
			appContext.setGlobalSpinnerCount(Math.max(appContext.globalSpinnerCount - 1, 0));
		});

	}
	
	return (
		<>
		  <div className="form-group col-md-12 text-left row-magic">
			{BNLabelType == "NotCounsel" ? 
				<TextFieldWithLabel id="ace_businessnumber" name="ace_businessnumber" required={true} placeholder={messages["sima.account.accountInfo.businessNumber.example"]} maxLength="15" label={messages["sima.representative.businessNumber.name.other"]}/>
			: BNLabelType == "Counsel" ?
				<TextFieldWithLabel id="ace_businessnumber" name="ace_businessnumber" required={true} placeholder={messages["sima.account.accountInfo.businessNumber.example"]} maxLength="15" label={messages["sima.representative.businessNumber.counsel"]}/>
			: <TextFieldWithLabel id="ace_businessnumber" name="ace_businessnumber" required={true} placeholder={messages["sima.account.accountInfo.businessNumber.example"]} maxLength="15" label={messages["sima.account.accountInfo.businessNumber"]}/>			
			}
			<div className="form-group col-md-12 text-left magical-incantation">
				<div className="form-group col-md-12">
					<button type="button" id="search-MDM"
						onClick={() => handleBusinessSearchClick()}
						className="btn btn-primary"
					>
						<FormattedMessage id="wet.search"/> 
						<span className="glyphicon glyphicon-search"></span>
					</button>
					<p></p>
					<p><FormattedMessage id="sima.account.accountInfo.businessNumber.description" values={{i: chunks => <i>{chunks}</i>}} /></p>
				</div>
			</div>
			<TextFieldWithLabel id="companyLegalName" name="companyLegalName" disabled={true} placeholder={businessData.companyLegalName} maxLength="25" label={messages["sima.account.accountInfo.companyLegalName.label"]}/>
			<TextFieldWithLabel id="companyOperatingName" name="companyOperatingName" disabled={true} placeholder={businessData.companyOperatingName} maxLength="25" label={messages["sima.account.accountInfo.companyOperatingName.label"]}/>
			<TextFieldWithLabel id="companyAddress" name="companyAddress" disabled={true} placeholder={businessData.companyAddress} maxLength="25" label={messages["sima.account.accountInfo.companyAddress.label"]}/>
			<TextFieldWithLabel id="companyCity" name="companyCity" disabled={true} placeholder={businessData.companyCity} maxLength="25" label={messages["sima.account.accountInfo.companyCity.label"]}/>
			<TextFieldWithLabel id="companyCountry" name="companyCountry" disabled={true} placeholder={businessData.companyCountry} maxLength="25" label={messages["sima.account.accountInfo.companyCountry.label"]}/>
			<TextFieldWithLabel id="companyProvince" name="companyProvince" disabled={true} placeholder={businessData.companyProvince} maxLength="25" label={messages["sima.account.accountInfo.companyProvince.label"]}/>
			<TextFieldWithLabel id="companyPostalZipCode" name="companyPostalZipCode" disabled={true} placeholder={businessData.companyPostalZipCode} maxLength="25" label={messages["sima.account.accountInfo.companyPostalZipCode.label"]}/>
			<TextFieldWithLabel id="Telephone1" name="Telephone1" disabled={true} placeholder={businessData.Telephone1} maxLength="25" label={messages["common.phoneNumber"]}/>
			
			{ConfirmClient == "Yes" ? 
				<>
					<SelectFieldWithLabel id="role" name="role" disabled={disableOnSubmit} required={true} label={messages["sima.client.role"]}
						options={[
							{value:null, label: messages["common.select..."]}
							, ...clientRoles
						]}
					/>
					<RadioButtonsWithLabel id="clientConfirm" name="clientConfirm" disabled={disableOnSubmit} required={true} label={messages["sima.account.accountInfo.clientCertify.radio"]} 
						options={constants.yesNo[currentLang()]}
					/>
					<div>
						<div className="form-group col-md-2 text-left">
							<button type="button" disabled={disableOnSubmit}
								onClick={() => {console.log("confirm client")}} 
								className="btn btn-primary"
							>
								<FormattedMessage id="sima.account.accountInfo.clientCertify.confirm.button"/> 
								{/* <span className="glyphicon glyphicon-chevron-right"></span> */}
							</button>
						</div>
						<div className="form-group col-md-6 text-left">
							<button type="button" disabled={disableOnSubmit}
								onClick={() => {console.log("add another client")}} 
								className="btn btn-primary"
							>
								<FormattedMessage id="sima.account.accountInfo.clientCertify.confirmAndAdd.button"/> 
								{/* <span className="glyphicon glyphicon-chevron-right"></span> */}
							</button>
						</div>
					</div>
					
					
				</>
			: <>
				<CheckboxWithLabel id="registrantInfoFirm" name="registrantInfoFirm" disabled={disableFirmCheckboxFromInitialValue} required={false} label={labels["sima.account.accountInfo.registrantInfoCheck.radio"]} 
					options={[{
						value: "yes"
						, required: false
						, label: labels["label.yes"]
					}]}
				/>
				<div className="form-group col-md-12 text-left magical-incantation">
					<div className="form-group col-md-12">
						<p><FormattedMessage id="label.yes.member.of.firm.authorized" values={{i: (chunks) => <i>{chunks}</i>}}/></p>
					</div>
				</div>
			</>
			}
		  </div>
		  
		</>
	);
}

